import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

// Google Cloud "Compute Engine" product icon, redrawn on the codebase's
// 40×40 icon grid with a white chip outline around the original colours.
function createGcpInstanceIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M23.8182 11.0909H21.2727V12.3636H18.7273V11.0909H21.2727V7.27273H18.7273V11.0909H16.1818V12.3636H13.6364V11.0909H16.1818V7.27273H13.6364V11.0909H11.0909V13.6364H7.27273V16.1818H11.0909V13.6364H12.3636V16.1818H11.0909V18.7273H7.27273V21.2727H11.0909V18.7273H12.3636V21.2727H11.0909V23.8182H7.27273V26.3636H11.0909V23.8182H12.3636V26.3636H11.0909V28.9091H13.6364V27.6364H16.1818V28.9091H13.6364V32.7273H16.1818V28.9091H18.7273V27.6364H21.2727V28.9091H18.7273V32.7273H21.2727V28.9091H23.8182V27.6364H26.3636V28.9091H23.8182V32.7273H26.3636V28.9091H28.9091V26.3636H27.6364V23.8182H28.9091V26.3636H32.7273V23.8182H28.9091V21.2727H27.6364V18.7273H28.9091V21.2727H32.7273V18.7273H28.9091V16.1818H27.6364V13.6364H28.9091V16.1818H32.7273V13.6364H28.9091V11.0909H26.3636V12.3636H23.8182V11.0909H26.3636V7.27273H23.8182V11.0909ZM27.6364 9.81818H30.1818V12.3636H34V27.6364H30.1818V30.1818H27.6364V34H12.3636V30.1818H9.81818V27.6364H6V12.3636H9.81818V9.81818H12.3636V6H27.6364V9.81818Z" fill="white"/>
    <path d="M23.8182 11.0909H21.2727V12.3636H18.7273V11.0909H16.1818V12.3636H13.6364V11.0909H11.0909V13.6364H12.3636V16.1818H11.0909V18.7273H12.3636V21.2727H11.0909V23.8182H12.3636V26.3636H11.0909V28.9091H13.6364V27.6364H16.1818V28.9091H18.7273V27.6364H21.2727V28.9091H23.8182V27.6364H26.3636V28.9091H28.9091V26.3636H27.6364V23.8182H28.9091V21.2727H27.6364V18.7273H28.9091V16.1818H27.6364V13.6364H28.9091V11.0909H26.3636V12.3636H23.8182V11.0909Z" fill="white"/>
    <path d="M23.8182 16.1818H16.1818V23.8182H23.8182V16.1818Z" fill="#AECBFA"/>
    <path d="M21.2727 7.27271H18.7273V12.3636H21.2727V7.27271Z" fill="#669DF6"/>
    <path d="M16.1818 7.27271H13.6363V12.3636H16.1818V7.27271Z" fill="#669DF6"/>
    <path d="M26.3636 7.27271H23.8182V12.3636H26.3636V7.27271Z" fill="#669DF6"/>
    <path d="M21.2727 27.6363H18.7273V32.7272H21.2727V27.6363Z" fill="#4285F4"/>
    <path d="M16.1818 27.6363H13.6363V32.7272H16.1818V27.6363Z" fill="#4285F4"/>
    <path d="M26.3636 27.6363H23.8182V32.7272H26.3636V27.6363Z" fill="#4285F4"/>
    <path d="M27.6363 18.7273V21.2727H32.7272V18.7273H27.6363Z" fill="#4285F4"/>
    <path d="M27.6363 23.8182V26.3636H32.7272V23.8182H27.6363Z" fill="#4285F4"/>
    <path d="M27.6363 13.6363V16.1818H32.7272V13.6363H27.6363Z" fill="#4285F4"/>
    <path d="M7.27271 18.7273V21.2727H12.3636V18.7273H7.27271Z" fill="#669DF6"/>
    <path d="M7.27271 23.8182V26.3636H12.3636V23.8182H7.27271Z" fill="#669DF6"/>
    <path d="M7.27271 13.6363V16.1818H12.3636V13.6363H7.27271Z" fill="#669DF6"/>
    <path d="M11.0909 11.0909V28.9091H28.9091V11.0909H11.0909ZM26.3636 26.3636H13.6363V13.6363H26.3636V26.3636Z" fill="#AECBFA"/>
    <path d="M16.1818 23.8182H23.8182L20 20L16.1818 23.8182Z" fill="#669DF6"/>
    <path d="M20 20L23.8182 23.8182V16.1818L20 20Z" fill="#4285F4"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const gcpInstanceIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createGcpInstanceIcon,
);
